import {
  getMergedPermissionsFromLocalStorage,
  hasModulePermission,
  hasAppPageAccess,
  hasSurveyPageAccess
} from '@/utils/permissions'

const STORAGE_PREFIX = 'tabs:'

export function routeToTab(route) {
  return {
    key: route.path,
    title: route.meta?.title || route.name || route.path,
    name: route.name,
    path: route.path,
    fullPath: route.fullPath,
    affix: !!route.meta?.affix,
    keepAlive: route.meta?.keepAlive !== false,
    lastActive: Date.now()
  }
}

export function isTabbable(route) {
  if (!route.path.startsWith('/main')) return false
  if (route.meta?.noTab) return false
  if (route.meta?.hideLayout) return false
  return true
}

export function getStorageKey(userId) {
  return `${STORAGE_PREFIX}${userId || 'anonymous'}`
}

export function loadTabs(userId) {
  try {
    const raw = localStorage.getItem(getStorageKey(userId))
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function saveTabs(userId, payload) {
  try {
    localStorage.setItem(getStorageKey(userId), JSON.stringify(payload))
  } catch (e) {
    console.warn('保存 tabs 失败:', e)
  }
}

export function clearTabsStorage(userId) {
  try {
    localStorage.removeItem(getStorageKey(userId))
  } catch {
    // ignore
  }
}

export function getCurrentUserId() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return user?.id || user?._id || user?.userId || 'anonymous'
  } catch {
    return 'anonymous'
  }
}

export function filterValidTabs(tabs, router) {
  if (!Array.isArray(tabs)) return []
  const userRole = localStorage.getItem('role')
  const perms = getMergedPermissionsFromLocalStorage()
  return tabs.filter((tab) => {
    try {
      const resolved = router.resolve(tab.fullPath || tab.path)
      if (!resolved.matched || resolved.matched.length === 0) return false

      // roles check (深层 roles 以最深层为准，与守卫一致)
      const recordsWithRoles = resolved.matched.filter((r) => r.meta?.roles)
      if (recordsWithRoles.length > 0) {
        const allowedRoles =
          recordsWithRoles[recordsWithRoles.length - 1].meta.roles
        if (!allowedRoles.includes(userRole)) return false
      }

      // forbidRoles
      const forbidRoles = resolved.matched.flatMap(
        (r) => r.meta?.forbidRoles || []
      )
      if (userRole && forbidRoles.includes(userRole)) return false

      // permissions: 任一通过即可（与守卫 some 一致）
      const requiredPerms = resolved.matched
        .flatMap((r) => r.meta?.permissions || [])
        .filter((p) => p && p.module && p.action)
      if (requiredPerms.length === 0) return true
      return requiredPerms.some((p) => {
        if (p.module === 'survey_page') {
          return p.action === 'view' && hasSurveyPageAccess(userRole, perms)
        }
        if (p.module === 'app_pages') {
          return hasAppPageAccess(userRole, perms, p.action)
        }
        return hasModulePermission(userRole, perms, p.module, p.action)
      })
    } catch {
      return false
    }
  })
}
